import { createSlice } from "@reduxjs/toolkit";
import { AddProduct, UpdateProduct, GetProducts, GetStockByBarcode } from "services/inventory/product.service";
import { toast } from 'react-toastify';

export const productListSlice = createSlice({
  name: "productList",
  initialState: {
    productList: [],
    productListLoading: false,
    productListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetProducts.pending, (state) => {
      //toast.loading('Promise is pending...') // we may get a warning error in browser console.
      state.productListLoading = true
    });

    builder.addCase(GetProducts.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Promise resolved 👌');

      state.productList = action.payload
      state.productListLoading = false
      state.productListError = null
    });

    builder.addCase(GetProducts.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Promise rejected 🤯 😣')

      state.productListLoading = false
      state.productListError = action.error?.message
    });
  },
});

export const productAddSlice = createSlice({
  name: "productAdd",
  initialState: {
    productAdd: {},
    productAddLoading: false,
    productAddError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(AddProduct.pending, (state) => {
      // toast.loading('We are adding the product 🤯')
      state.productAddLoading = true
    });

    builder.addCase(AddProduct.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('New product added successfully 👌');

      state.productAdd = action.payload
      state.productAddLoading = false
      state.productAddError = null
    });

    builder.addCase(AddProduct.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the product 😣")

      state.productAddLoading = false
      state.productAddError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const productUpdateSlice = createSlice({
  name: "productUpdate",
  initialState: {
    productUpdate: {},
    productUpdateLoading: false,
    productUpdateError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateProduct.pending, (state) => {
      // toast.loading('We are updating the product 🤯')
      state.productUpdateLoading = true
    });

    builder.addCase(UpdateProduct.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Product update successfully 👌');

      state.productUpdate = action.payload
      state.productUpdateLoading = false
      state.productUpdateError = null
    });

    builder.addCase(UpdateProduct.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't update the product 😣")

      state.productUpdateLoading = false
      state.productUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const stockByBarcodeSlice = createSlice({
  name: "stockByBarcode",
  initialState: {
    stockByBarcode: null,
    stockByBarcodeLoading: false,
    stockByBarcodeError: null,
  },
  reducers: {
    nullifyStockByBarcodeValue: (state) => { // nulling the last scanning data from state
      state.stockByBarcode = null; // Assign null to the state field
    },
  },
  extraReducers: 
  (builder) => {
    builder.addCase(GetStockByBarcode.pending, (state) => {
      //toast.loading('Promise is pending...') // we may get a warning error in browser console.
      state.stockByBarcodeLoading = true
    });

    builder.addCase(GetStockByBarcode.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Stock Promise resolved 👌');
      state.stockByBarcode = action.payload
      state.stockByBarcodeLoading = false
      state.stockByBarcodeError = null
    });

    builder.addCase(GetStockByBarcode.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Stock Not Found. 🤯 😣')

      state.stockByBarcodeLoading = false
      state.stockByBarcodeError = action.error?.message
    });
  },
});

export const { nullifyStockByBarcodeValue } = stockByBarcodeSlice.actions